import { sha1 } from 'js-sha1'

export class HttpUtil {
  static getHTVBasicAuth(user: string): string {
    return 'Basic ' + this.getHTVAuthToken(user)
  }

  static getHTVAuthToken(user: string): string {
    const hash1 = sha1.create()
    hash1.update(user)
    const tmp1 = hash1.hex()
    const tmp2 = tmp1.substring(3, tmp1.length - 3)
    const hash2 = sha1.create()
    hash2.update(tmp2)
    const password = hash2.hex()
    const auth = btoa(`${user}:${password}`)
    return auth
  }
}
